"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3361],{

/***/ 3361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionSpecialOffer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(155);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8352);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9741);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}















function SectionSpecialOffer(param1) {
    var _isParador = param1.isParador, isParador = _isParador === void 0 ? false : _isParador, _isHomepage = param1.isHomepage, isHomepage = _isHomepage === void 0 ? true : _isHomepage, hotelName = param1.hotelName, hotelLoc = param1.hotelLoc, _variant = param1.variant, variant = _variant === void 0 ? "smooth" : _variant, _color = param1.color, color = _color === void 0 ? "black" : _color, _limit = param1.limit, limit = _limit === void 0 ? 5 : _limit, _slug = param1.slug, slug1 = _slug === void 0 ? "" : _slug, hotelCode = param1.hotelCode, hotel1 = param1.hotel;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var locale = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useLocale */ .bU)();
    var params = isParador ? {
        _limit: limit,
        cct_status: "publish",
        is_group_offer: true
    } : {
        _limit: limit,
        cct_status: "publish",
        hotel_name: hotelName
    };
    var ref8 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useFetchSWRv2 */ .bX)("special_offers", params), 3), offersData = ref8[0], isLoading = ref8[1], isError = ref8[2];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(true), isAllLoading = ref1[0], setIsAllLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), data = ref2[0], setData = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (offersData) {
            if (isParador) {
                setData(offersData);
            } else {
                (0,_utils_api__WEBPACK_IMPORTED_MODULE_11__/* .getSpecialOffer */ .Mc)({
                    _limit: limit,
                    cct_status: "publish",
                    is_private: "false",
                    hotel_name: hotel1,
                    is_group_offer: false
                }).then(function(res) {
                    setData(res.data);
                });
            }
        }
    }, [
        offersData
    ]);
    var hotels = (0,_utils_hooks__WEBPACK_IMPORTED_MODULE_13__/* .useGetListHotel */ .e7)().hotels;
    var ref3 = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .useLargeQuery */ .fc)(), is2XLarge = ref3.is2XLarge, isXLarge = ref3.isXLarge;
    // const bulletsRef = useRef(null);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(), selectedHotel = ref4[0], setSelectedHotel = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(), selectedPlaceholder = ref5[0], setSelectedPlaceholder = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(), selectedPlaceholder2 = ref6[0], setSelectedPlaceholder2 = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]), defaultSelected = ref7[0], setDefaultSelected = ref7[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (!data || !hotels) return;
        var temp = data.map(function(param, i) {
            var hotel_name = param.hotel_name, hotel_names = param.hotel_names;
            return (0,lodash__WEBPACK_IMPORTED_MODULE_2__.find)(hotels, function(o) {
                return o.name == hotel_names ? hotel_names[0] : hotel_name;
            });
        });
        setDefaultSelected(temp);
    }, [
        data,
        hotels
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (!isLoading && data !== null) {
            setIsAllLoading(false);
        }
    }, [
        isLoading,
        data
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: "section-special-offers",
        variant: "zero",
        bg: "white",
        color: color,
        py: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .safeMarginY */ .iM,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        mb: 2,
                        as: "h2",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .safeMarginX */ .Mp,
                        children: locale == "id" ? "Promo Spesial" : isParador ? "Special Offers" : "Hotel Offers"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                        mb: 8,
                        color: "blackAlpha.800",
                        px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .safeMarginX */ .Mp,
                        children: isParador ? locale == "id" ? "Dapatkan penawaran eksklusif untuk menikmati pengalaman menginap di seluruh hotel kami di Indonesia." : "Get the exclusive promotions to experience our hotels all across Indonesia." : "".concat(locale == "id" ? "Dapatkan penawaran eksklusif dari" : "Exciting offers and promotions from", " ").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .capEachWord */ .x8)(hotelName), " ").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .capEachWord */ .x8)(hotelLoc), ".")
                    }),
                    isLoading || isAllLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                        h: "60vh",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$jN, {
                            size: "xl"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .tq, {
                        speed: 1000,
                        centeredSlides: true,
                        loop: true,
                        pagination: {
                            clickable: true
                        },
                        autoplay: {
                            delay: 8000,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: true
                        },
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt,
                            swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl
                        ],
                        className: "mySwiper",
                        children: data && !isError && !isLoading && data.map(function(param, i) {
                            var thumb = param.thumb, thumb_banner = param.thumb_banner, slug = param.slug, title = param.title, title_id = param.title_id, desc_short = param.desc_short, desc_short_id = param.desc_short_id, start_from = param.start_from, rate = param.rate, promo = param.promo, hotel_names = param.hotel_names, connect_to_synxis = param.connect_to_synxis, promo_url = param.promo_url, is_private = param.is_private, coupon = param.coupon, dest = param.dest, arrive = param.arrive, depart = param.depart, date_end = param.date_end;
                            if (is_private === true || is_private === "true" || new Date(date_end * 1000) <= new Date()) return null;
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                    direction: "column",
                                    color: "black",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                            h: [
                                                "30vh",
                                                "50vh",
                                                "75vh"
                                            ],
                                            w: "100%",
                                            position: "relative",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                layout: "fill",
                                                objectFit: "cover",
                                                src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .convertImgHttps */ .Nu)(thumb_banner != null ? thumb_banner : thumb),
                                                alt: slug,
                                                priority: true,
                                                unoptimized: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Grid */ .rjZ, {
                                            px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_14__/* .safeMarginX */ .Mp,
                                            templateRows: {
                                                base: "repeat(3, minmax(min-content))",
                                                lg: "repeat(4, minmax(min-content))"
                                            },
                                            templateColumns: {
                                                base: "1fr",
                                                lg: "10% 40% 40% 10%",
                                                xl: "15% 35% 35% 15%",
                                                "2xl": "repeat(4, 1fr)"
                                            },
                                            rowGap: 2,
                                            mt: 12,
                                            children: [
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                                                        as: "h3",
                                                        size: "lg",
                                                        fontWeight: 400,
                                                        letterSpacing: "wide",
                                                        children: locale == "id" ? title_id !== null && title_id !== void 0 ? title_id : title : title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        color: "gray.700",
                                                        textAlign: isXLarge && "justify",
                                                        className: "max-text-5-line",
                                                        children: locale == "id" ? desc_short_id : desc_short
                                                    })
                                                }),
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                }),
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1,
                                                    children: start_from > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                                        textTransform: "capitalize",
                                                        color: "gray.700",
                                                        mt: !isXLarge && 2,
                                                        children: [
                                                            locale == "id" ? "Harga mulai" : "Start from",
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .formatRupiah */ .b7)(start_from)
                                                            })
                                                        ]
                                                    })
                                                }),
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                }),
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                }),
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: isXLarge ? 2 : 1,
                                                    mt: 8,
                                                    children: hotels && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                                                        h: "100%",
                                                        w: "100%",
                                                        align: "center",
                                                        boxSizing: "border-box",
                                                        border: isParador && start_from > 0 ? "1px solid var(--chakra-colors-gray-700)" : "none",
                                                        children: [
                                                            isParador && start_from > 0 && (hotel_names ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .PhF, {
                                                                h: "100%",
                                                                border: 0,
                                                                _focus: {},
                                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoChevronDown */ .CgR, {
                                                                    opacity: 0.5,
                                                                    size: "10px"
                                                                }),
                                                                onChange: function(e) {
                                                                    setSelectedHotel(JSON.parse(e.target.value));
                                                                },
                                                                value: selectedPlaceholder,
                                                                children: hotel_names.map(function(n) {
                                                                    var tempHotel = (0,lodash__WEBPACK_IMPORTED_MODULE_2__.find)(hotels, function(o) {
                                                                        return o.name == n;
                                                                    });
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: JSON.stringify(tempHotel),
                                                                        children: n
                                                                    }, n);
                                                                })
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .PhF, {
                                                                h: "100%",
                                                                border: 0,
                                                                _focus: {},
                                                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoChevronDown */ .CgR, {
                                                                    opacity: 0.5,
                                                                    size: "10px"
                                                                }),
                                                                onChange: function(e) {
                                                                    var temp = JSON.parse(e.target.value);
                                                                    setSelectedHotel(temp);
                                                                },
                                                                value: JSON.stringify(selectedHotel),
                                                                children: hotels.map(function(hotel, hi) {
                                                                    var tempHotel = JSON.stringify(hotel);
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                        value: tempHotel,
                                                                        children: hotel.name
                                                                    }, hotel.name + hi);
                                                                })
                                                            })),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                                                                w: isParador && start_from > 0 ? "unset" : "100%",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                                                                    h: "100%",
                                                                    w: (!isParador || start_from == 0) && "100%",
                                                                    variant: "dark",
                                                                    boxSizing: "border-box",
                                                                    bg: color,
                                                                    borderColor: color,
                                                                    _hover: {
                                                                        opacity: 0.8
                                                                    },
                                                                    onClick: function() {
                                                                        if (connect_to_synxis == "false") {
                                                                            window.open(promo_url, start_from > 0 ? "_blank" : "_self");
                                                                        } else {
                                                                            var ref;
                                                                            var targetCode = isParador ? selectedHotel ? selectedHotel.hotel_code : (ref = defaultSelected[i]) === null || ref === void 0 ? void 0 : ref.hotel_code : hotelCode;
                                                                            var cfg = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .getBookingEngineHotelConfig */ .Np)(targetCode);
                                                                            var action = cfg ? cfg.action : "https://www.secure-hotel-booking.com/Parador-Hotels-Resorts/J37Y/search";
                                                                            (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .submitBookingEngineForm */ .Sw)({
                                                                                action: action,
                                                                                fields: {
                                                                                    language: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .getBookingEngineLocale */ .cG)(router.locale),
                                                                                    arrivalDate: arrive !== null && arrive !== void 0 ? arrive : "",
                                                                                    nights: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .getBookingEngineNights */ .cl)(arrive, depart),
                                                                                    guestCountSelector: "ReadOnly",
                                                                                    crossSell: "false",
                                                                                    selectedAdultCount: "2",
                                                                                    rate: rate !== null && rate !== void 0 ? rate : "",
                                                                                    promo: promo !== null && promo !== void 0 ? promo : "",
                                                                                    coupon: coupon !== null && coupon !== void 0 ? coupon : ""
                                                                                }
                                                                            });
                                                                        }
                                                                    },
                                                                    children: locale == "id" ? "Pesan" : "Book Now"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .GridItem */ .P4e, {
                                                    rowSpan: 1,
                                                    colSpan: 1
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, i);
                        })
                    })
                ]
            }),
            isHomepage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                mt: 4,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                    variant: "dark",
                    _hover: {
                        bg: "white",
                        color: color,
                        borderColor: color,
                        borderWidth: 1
                    },
                    borderColor: color,
                    onClick: function() {
                        return router.push(isParador ? "/special-offers" : "/".concat(slug1, "/hotel-offers"));
                    },
                    bg: color,
                    children: locale == "id" ? "Lebih Banyak" : "See More"
                })
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ })

}]);